<template>
    <div>
        <el-card>
            <div id="chart" style="width: 100%;height:300px;"></div>
        </el-card>
        <br>
        <el-card>
            <el-table :data="tableData" :default-sort="{prop: 'time', order: 'descending'}">
                <el-table-column prop="time" label="时间" width="160" sortable></el-table-column>
                <el-table-column prop="code" label="通道" :filters="channels">
                    <template #default="{row}">
                        {{getChannelName(row.code)}}
                    </template>
                </el-table-column>
                <el-table-column prop="send" label="总数" width="100" sortable></el-table-column>
                <el-table-column prop="success" label="成功数" width="100" sortable></el-table-column>
                <el-table-column prop="fail" label="失败数" width="100" sortable></el-table-column>
            </el-table>
        </el-card>
    </div>
</template>

<script>
    import echarts from 'echarts'
    import moment from 'moment'

    export default {
        data() {
            return {
                channels: [],
                types: ["send", "success", "fail"],
                timeout: "",
                chart: null,
                tableData: [],
                times: []
            }
        },
        mounted() {
            let options = [];
            this.$axios.post("/channel/list").then(results => {
                results.forEach(result => {
                    options.push({value: result.code, text: result.name});
                });
                this.channels = options;

                const myChart = echarts.init(document.getElementById("chart"));
                myChart.setOption({
                        title: {
                            text: '通道监控'
                        },
                        legend: {
                            data: ['总数', '成功数', '失败数']
                        },
                        tooltip: {
                            trigger: 'axis'
                        },
                        grid: {
                            left: '3%',
                            right: '4%',
                            bottom: '3%',
                            containLabel: true
                        },
                        xAxis: {
                            type: 'category',
                            boundaryGap: false,
                            data: []
                        },
                        yAxis: {
                            type: 'value'
                        },
                        series: []
                    }
                );

                this.chart = myChart;
                this.load();
            });
        },
        methods: {
            load() {
                this.$axios.get("/monitor/channel").then((result) => {
                    this.refreshChart(result);
                    this.refreshTable(result);

                    const vue = this;
                    this.timeout = setTimeout(() => {
                        vue.load();
                    }, 10000);
                });
            },
            getChannelName(val) {
                let name = val;
                this.channels.forEach(option => {
                    if (val === option.value) {
                        name = option.text;
                        return false;
                    }
                });
                return name;
            },
            refreshChart(result) {
                const options = {
                    xAxis: {
                        data: []
                    },
                    series: [
                        {
                            name: '总数',
                            type: 'line',
                            data: []
                        },
                        {
                            name: '成功数',
                            type: 'line',
                            data: []
                        },
                        {
                            name: '失败数',
                            type: 'line',
                            data: []
                        }
                    ]
                };

                // 统计出所有的时间点
                const times = {};
                Object.keys(result).forEach(code => {
                    this.types.forEach(type => {
                        if (result[code][type]) {
                            Object.keys(result[code][type]).forEach(time => {
                                if (!times[time]) {
                                    times[time] = {};
                                }

                                let num = result[code][type][time];
                                if (num) {
                                    num = parseInt(num);
                                } else {
                                    num = 0;
                                }

                                if (times[time][type]) {
                                    times[time][type] = times[time][type] + num;
                                } else {
                                    times[time][type] = num;
                                }
                            })
                        }
                    })
                });

                Object.keys(times).forEach(time => {
                    options.xAxis.data.push(moment.unix(time * 60).format("HH:mm"));
                    options.series[0].data.push(times[time]['send'] ? times[time]['send'] : 0);
                    options.series[1].data.push(times[time]['success'] ? times[time]['success'] : 0);
                    options.series[2].data.push(times[time]['fail'] ? times[time]['fail'] : 0);
                });

                this.chart.setOption(options);
            },
            refreshTable(result) {
                let data = [];

                // 统计出所有的时间点
                Object.keys(result).forEach(code => {
                    let times = {};
                    this.types.forEach(type => {
                        if (result[code][type]) {
                            Object.keys(result[code][type]).forEach(time => {
                                if (!times[time]) {
                                    times[time] = {};
                                }

                                times[time][type] = result[code][type][time];
                            })
                        }
                    });
                    Object.keys(times).forEach(time => {
                        data.push({
                            code: code,
                            time: moment.unix(time * 60).format("YYYY-MM-DD HH:mm"),
                            send: times[time]['send'] ? times[time]['send'] : 0,
                            success: times[time]['success'] ? times[time]['success'] : 0,
                            fail: times[time]['fail'] ? times[time]['fail'] : 0
                        });
                    });
                });

                this.tableData = data;
            }
        },
        beforeDestroy() {
            clearTimeout(this.timeout);
        }
    }
</script>